module.exports = __webpack_public_path__ + "static/media/hr_resources.eae1ee27.png";